import numeral from 'numeral'

export function formatNum(number: number | string, format?: string) {
  numeral.zeroFormat('0')
  const defaultFormat = number < 1000 ? '0a' : '0.0a'
  const output = numeral(number).format(format || defaultFormat)
  return output
}
